














import Vue from "vue";
import { required, requiredIf } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import LineStopSyncEditorForm from "../components/LineStopSyncEditorForm.vue";
import { LineStopSyncCreateForm } from "../forms/LineStopSyncCreateForm";
import { Line } from "../models/Line";

export default Vue.extend({
  mixins: [dialog],
  components: {
    LineStopSyncEditorForm
  },
  validations: {
    lineStopSyncCreateForm: {
      shop: { required },
      fromDate: {
        required: requiredIf(function(this: any) {
          return !this.lineStopSyncCreateForm.isStartImmediately;
        })
      },
      untilDate: { required }
    }
  },
  data() {
    const shops: Line[] = [];
    const lineStopSyncCreateForm: LineStopSyncCreateForm = {
      isStartImmediately: false
    };

    return { shops, lineStopSyncCreateForm };
  },
  async created() {
    await Promise.all([this.getShopsLine()]);
  },
  methods: {
    async getShopsLine() {
      try {
        const { data } = await (this as any).$dep.lineUseCase.getLine({
          perPage: 9999
        });

        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToLineStopSyncViewPage() {
      this.$router.push({ name: "LineStopSyncViewPage" });
    },
    async createLineStopSync() {
      try {
        await (this as any).$dep.lineUseCase.createlineStopSync(
          this.lineStopSyncCreateForm
        );

        if (
          await (this as any).alertSuccess(
            "Success",
            "หยุดการ Sync ชั่วคราวสำเร็จ"
          )
        ) {
          this.goToLineStopSyncViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถหยุดการ Sync ชั่วคราวได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      console.log(this.lineStopSyncCreateForm);
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to stop sync",
        "คุณต้องการหยุดการ Sync ชั่วคราวหรือไม่ ?"
      );

      if (isConfirmed) {
        await this.createLineStopSync();
      }
    },
    clear() {
      this.$v.$reset();
      this.lineStopSyncCreateForm = {
        isStartImmediately: false
      };
    }
  }
});
